<template>
  <!-- 진단 패키지 JSON 클립보드 복사 (ux-patterns.md §11.5) -->
  <a-button
    size="small"
    :loading="copying"
    :icon="h(copying ? CheckOutlined : CopyOutlined)"
    @click="handleCopy"
    :title="$t('ecountEtl_diagnostic_copyTitle')"
  >
    {{ copying ? $t('ecountEtl_diagnostic_copied') : $t('ecountEtl_diagnostic_copy') }}
  </a-button>
</template>

<script>
// @MX:SPEC: SPEC-ECOUNT-ETL-OPS-CONSOLE-001 REQ-OC-RUNS-006, REQ-OC-DEADLETTERS-005
import { h, ref } from 'vue';
import { CopyOutlined, CheckOutlined } from '@ant-design/icons-vue';
import { useClipboard } from '../composables/useClipboard.js';
import { message } from 'ant-design-vue';

export default {
  name: 'DiagnosticPackageCopy',
  components: { CopyOutlined, CheckOutlined },
  props: {
    // run-detail 모드: runId + items(dead-letter 배열)
    runId: { type: [String, Number], default: null },
    items: { type: Array, default: null },
    // single dead-letter 모드: 단일 deadLetter 객체
    deadLetter: { type: Object, default: null },
  },
  setup(props) {
    const { copy, copying } = useClipboard();

    // 진단 패키지 JSON 생성
    function buildPackage() {
      // single dead-letter 모드
      if (props.deadLetter) {
        return {
          mode: 'single',
          capturedAt: new Date().toISOString(),
          deadLetter: props.deadLetter,
        };
      }
      // run-detail 모드
      return {
        mode: 'run',
        runId: props.runId,
        capturedAt: new Date().toISOString(),
        totalDeadLetters: props.items ? props.items.length : 0,
        items: props.items || [],
      };
    }

    async function handleCopy() {
      const pkg = buildPackage();
      const text = JSON.stringify(pkg, null, 2);
      const ok = await copy(text);
      if (!ok) {
        // 복사 실패 시 메시지
        message.error('클립보드 복사에 실패했습니다.');
      }
    }

    return { h, copying, handleCopy };
  },
};
</script>
